import { render, staticRenderFns } from "./look.vue?vue&type=template&id=5aa17921&scoped=true&"
import script from "./look.vue?vue&type=script&lang=js&"
export * from "./look.vue?vue&type=script&lang=js&"
import style0 from "./look.vue?vue&type=style&index=0&id=5aa17921&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa17921",
  null
  
)

export default component.exports